import styled, { css } from 'styled-components'
import { phoneMaxWidth, fontSize } from '../../DashboardSettings.styles'
import { colors, fonts } from 'modules/dashboard/Home/Dashboard.global.styles'

export const Content = styled.div`
  display: flex;
  justify-content: center;
  flex-flow: row wrap;
  max-width: 900px;
  margin: 15px auto 25px;
  padding: 20px 0;

  @media (max-width: ${phoneMaxWidth}px) {
    flex-flow: column wrap;
    margin: 0px auto;
    padding-top: 0px;
  }
`

export const ButtonColumn = styled.div`
  display: flex;
  flex-direction: column;
  width: 125px;
  margin-top: 20px;
  margin-left: 55px;

  @media (max-width: 900px) {
    margin-left: 0px;
  }
`

export const MobileButtons = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 220px;
  margin: auto;
`

export const DeleteAccountMessage = styled.p`
  max-width: 900px;
  margin: auto;
  padding-left: 170px;
  padding-right: 150px;
  font-size: 14px;
  color: ${colors.darkTeal};

  @media (max-width: 900px) {
    max-width: 615px;
    padding-left: 20px;
    padding-right: 50px;
  }

  @media (max-width: ${phoneMaxWidth}px) {
    width: 220px;
    padding-left: 0px;
    padding-right: 0px;
    margin-top: 20px;
    font-size: 12px;
  }
`

export const StyledLink = styled.a`
  color: ${colors.darkTeal};
`
